<sd-modal>
  <div class="wrapper">
    <h4>Адрес доставки</h4>
    <div class="list-wrapper">
      <sd-delivery-address-list></sd-delivery-address-list>
    </div>
  </div>
</sd-modal>
